import { useCallback, useEffect, useState } from 'react';
import UsuarioController from '../controllers/UsuarioController';
import { UsuarioProps } from '../shared/types/usuarioProps';
import { useForm } from './useForm';
import { UsuarioDetalheSchema } from '../schemas/UsuarioDetalheSchema';
import { useNavigate } from 'react-router-dom';
import { Usuario } from '../routes/RoutesNames';
import { toast } from 'react-toastify';

const useUsuarioCadastro = (userId: number | null) => {
  const navigation = useNavigate();
  const [usuario, setUsuario] = useState<UsuarioProps | any>({
    usu_nome: '',
    usu_login: '',
  });
  const [loading, setLoading] = useState<boolean>(false);

  const onSubmit = async (data: UsuarioProps) => {
    setLoading(true);
    if (userId) {
      const response = await UsuarioController.Atualizar({
        UsuarioId: userId,
        Nome: data.usu_nome,
        Login: data.usu_login,
        Senha: data.senha,
      });

      if (response.StatusCode === 204) {
        toast('Usuário atualizado com sucesso!', {
          type: 'success',
        });
      }
    } else {
      await UsuarioController.Adicionar({
        Nome: data.usu_nome,
        Login: data.usu_login,
        Senha: data.senha,
      });
      navigation(Usuario);
    }
    setLoading(false);
  };

  const backActions = () => {
    navigation(Usuario);
  };

  const getUserById = useCallback(async () => {
    if (!userId) return;
    try {
      setLoading(true);
      const response = await UsuarioController.Listar({
        UsuarioId: userId,
        Nome: '',
        Setor: '',
      });
      const userData = response?.Data?.[0];
      if (userData) {
        console.log(userData);
        setUsuario(userData);
      }
    } catch (error) {
      console.error('Error fetching user:', error);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  const form = useForm({
    onSubmit: onSubmit,
    initialValues: usuario,
    validationSchema: UsuarioDetalheSchema,
  });

  useEffect(() => {
    getUserById();
  }, [getUserById]);

  return {
    ...form,
    backActions,
    loading,
  };
};

export default useUsuarioCadastro;
